<script setup>
import { computed, getCurrentInstance } from 'vue';

// Access store via proxy
const { proxy } = getCurrentInstance();
const store = proxy.$store;

// Computed Property for User Preference
const twigMode = computed(() => {
    return store.getters['user/pref']('codeMirror_twigMode');
});

// Methods
const setPref = () => {
    store.dispatch('user/setPref', {
        name: 'codeMirror_twigMode',
        value: !twigMode.value
    });
};
</script>

<template>
    <button class="dropdown-item" type="button" @click="setPref">
        <span
            :class="{ 'bi-square': !twigMode, 'bi-check-square': twigMode }"
            class="me-2"
        />
        Highlight Twig code
    </button>
</template>